/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { ConfirmationDialogController } from '../component/ConfirmationDialog';

class DialogService {
    /** @ngInject */
    constructor($mdDialog, $log) {
        this.$mdDialog = $mdDialog;
        this.$log = $log;
        this.$log.debug('Service \'DialogService\' loaded');
    }

    /**
     * Shows a dialog based on an HTML template, handled by the given controller.
     *
     * @param {Object} controller Controller.
     * @param {String} templatePath Path to an HTML template, relative to the 'module' directory.
     * @param {Object} [data] Data injected in the controller, with 'data' key.
     */
    showDialog(controller, templatePath, data) {
        return this.$mdDialog.show({
            controller,
            controllerAs: '$ctrl',
            template: require('../../' + templatePath),
            fullscreen: true,
            locals: {
                data
            }
        });
    }

    /**
     * Shows a confirmation dialog with the given message.
     *
     * @param {String} messageKey Message key for translation.
     */
    showConfirmationDialogWithMessage(messageKey) {
        return this.showConfirmationDialogWithData({ messageKey });
    }

    /**
     * Shows a confirmation dialog with the given data.
     *
     * @param {Object} [data] Data injected in the controller, with 'data' key.
     */
    showConfirmationDialogWithData(data) {
        return this.showDialog(ConfirmationDialogController, 'util/component/confirmation-dialog.html', data);
    }

    /**
     * Shows a notification dialog with a message.
     *
     * @param {String} messageKey Message key for translation.
     */
    showMessageDialog(messageKey) {
        return this.showDialog(ConfirmationDialogController, 'util/component/confirmation-dialog.html', {
            messageKey,
            confirmKey: 'ui.button.close',
            cancelDisabled: true
        });
    }
}

export { DialogService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/util/service/DialogService.js